module.exports = __webpack_public_path__ + "static/media/sample-activity-report-us.bd858d10.pdf";